import Header from "./Header";
// import PublicPageBackground from "../../assets/Public_page_background.png";
import ATRAQ_LOGO_WITHOUT_LABEL from "../../assets/ATRAQ_LOGO_WITHOUT_LABEL.png";

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <div className="flex flex-1 flex-col lg:flex-row">
        {/* Left Section */}
        <div
          className="relative flex min-h-[220px] flex-col justify-center items-center bg-[#f8f8f8] px-6 py-10 sm:min-h-[280px] sm:px-8 lg:min-h-0 lg:w-1/2"
          style={{
            backgroundImage: `url(${ATRAQ_LOGO_WITHOUT_LABEL})`,
            backgroundSize: 'contain', // Make the logo fit without cropping
            backgroundRepeat: 'no-repeat', // Prevent tiling
            backgroundPosition: 'center' // Center the logo
          }}
        >
          <div className="relative z-10">
            <h1 className="max-w-xl text-center text-2xl font-bold text-gray-800 sm:text-3xl lg:text-4xl">
              Welcome to the ATraq Management Portal.
            </h1> 
          </div>
        </div>


        {/* Right Section */}
        <div className="flex w-full flex-1 flex-col justify-center items-center bg-white px-6 py-10 sm:px-10 lg:w-1/2 lg:px-12">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
